/* eslint-disable eqeqeq */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm, useFieldArray } from "react-hook-form";
import { Button, Card, CardBody, Flex, Checkbox } from "@chakra-ui/react";
import Loader from "../../components/PageLoader";
import BreadCrumb from "../../components/breadCrumb";
import { Paths } from "../../routes/paths";
import {
  useLookupPermissions,
  useLookupResources,
} from "../../services/lookups-queries";
import FormInput from "../../components/forms/form-Input";
import {
  useCreateRole,
  useEditRole,
  useGetRole,
} from "../../services/auth-api";
import { formDefaultValues } from "./constants";

export default function AddRole() {
  const navigate = useNavigate();
  const params = useParams();
  const {
    mutate: getRole,
    isSuccess: isRoleAvailable,
    data: roleDetails,
    isPending: gettingRole,
    // error: roleDetailsError,
    // reset: resetRole,
  } = useGetRole();
  const {
    mutate: createRequest,
    isSuccess: isRequestCreated,
    // data: createRequestResponse,
    isPending: creatingRequest,
    // error: createError,
  } = useCreateRole();
  const {
    mutate: editRoleRequest,
    isSuccess: isEditingSuccessful,
    // data: editRoleReqRes,
    isPending: requestingRoleEditing,
    // error: roleEditingRequestError,
  } = useEditRole();
  const {
    data: resourcesRes,
    isPending: gettingResources,
    // error: resourcesError,
  } = useLookupResources();
  const {
    data: rolePermissionRes,
    isPending: gettingRolePermission,
    // error: rolePermissionError,
  } = useLookupPermissions();
  const {
    handleSubmit,
    control,
    getValues,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: { ...formDefaultValues },
  });
  const formValidationRules = {
    role: { required: "Please Enter Role Name" },
    description: { required: "Please Enter Description" },
  };
  const generalFieldProps = { errors, control };
  const {
    fields: permissionsFields,
    append: permissionsAppend,
    remove: permissionsRemove,
  } = useFieldArray({
    control: generalFieldProps.control,
    name: "permissions",
  });

  useEffect(() => {
    if (params.roleName) {
      const name = params.roleName.split("_").join(" ");
      getRole(name);
    }
  }, []);

  useEffect(() => {
    if (isRoleAvailable && resourcesRes && rolePermissionRes) {
      reset({
        roleName: roleDetails.data.name,
        description: roleDetails.data.description,
        permissions: roleDetails.data.permissions.map((elm) => ({
          resource: elm.resourceKey,
          permission: elm.permissionKey,
        })),
      });
    }
  }, [isRoleAvailable, rolePermissionRes, resourcesRes]);

  useEffect(() => {
    if (isRequestCreated || isEditingSuccessful) {
      reset();
      navigate(Paths.roles);
    }
  }, [resourcesRes, rolePermissionRes, isEditingSuccessful, isRequestCreated]);

  const onSubmit = (data) => {
    const _payload = {
      name: data.roleName,
      description: data.description,
      permissions: data.permissions.map((elm) => ({
        resource: Number(elm.resource),
        permission: Number(elm.permission),
      })),
    };
    if (params.roleName) {
      editRoleRequest(_payload);
      return;
    }
    createRequest(_payload);
  };

  const addAllPermissions = (role) => {
    const rolesLength = permissionsFields.filter(
      (elm) => elm.resource == role.value
    );
    const _permissionFields = [];
    permissionsFields.forEach((elm) => {
      if (elm.resource !== role.value) {
        _permissionFields.push(elm);
      }
    });
    if (rolesLength.length !== rolePermissionRes.data.length) {
      rolePermissionRes.data.forEach((elm) => {
        _permissionFields.push({ resource: role.value, permission: elm.value });
      });
    }
    reset({ ...getValues(), permissions: [..._permissionFields] });
  };
  const updatePermission = (role, permission) => {
    const roleIndex = permissionsFields.findIndex(
      (elm) => elm.resource == role.value && elm.permission == permission.value
    );
    if (roleIndex !== -1) {
      permissionsRemove(roleIndex);
    } else {
      permissionsAppend({ resource: role.value, permission: permission.value });
    }
  };
  return (
    <>
      {creatingRequest ||
      gettingRolePermission ||
      gettingResources ||
      requestingRoleEditing ||
      gettingRole ? (
        <Loader />
      ) : (
        <></>
      )}

      <div className="form-container">
        <BreadCrumb
          links={[
            { text: "Roles", link: Paths.roles },
            {
              text: params.roleName ? "Edit Role" : "Create Role",
              isCurrentPage: true,
            },
          ]}
        />

        <Flex w="100%">
          <Card flexDirection="column" w="100%">
            <CardBody>
              <form
                onSubmit={handleSubmit(onSubmit)}
                className="add-location-form"
              >
                <FormInput
                  {...generalFieldProps}
                  isRequired
                  label="Role Name"
                  name="roleName"
                  rules={formValidationRules.role}
                />
                <FormInput
                  {...generalFieldProps}
                  isRequired
                  label="Description"
                  name="description"
                  rules={formValidationRules.description}
                />

                <table className="roles-perm-table">
                  <thead>
                    <tr>
                      <th style={{ textAlign: "start" }}>Role</th>
                      <th>Select All</th>
                      {rolePermissionRes?.data.map((perm, index) => (
                        <th width="100px" key={index}>
                          {perm.text}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {resourcesRes?.data.map((role, index) => (
                      <tr key={index}>
                        <td style={{ fontWeight: "bold" }}>{role.text}</td>
                        <td>
                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                            title={`${role.text}`}
                          >
                            <Checkbox
                              isChecked={
                                permissionsFields.filter(
                                  (elm) => elm.resource == role.value
                                ).length == rolePermissionRes?.data.length
                              }
                              onChange={() => {
                                addAllPermissions(role);
                              }}
                            />
                          </div>
                        </td>
                        {rolePermissionRes?.data.map((perm, index) => (
                          <td key={index}>
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                              title={`${perm.text}-${role.text}`}
                            >
                              <Checkbox
                                isChecked={
                                  permissionsFields.findIndex(
                                    (elm) =>
                                      elm.resource == role.value &&
                                      elm.permission == perm.value
                                  ) !== -1
                                }
                                onChange={() => {
                                  updatePermission(role, perm);
                                }}
                              />
                            </div>
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
                <Flex w="100%" justify="flex-end" flexDirection="row">
                  <Button type="submit">Submit</Button>
                </Flex>
              </form>
            </CardBody>
          </Card>
        </Flex>
      </div>
    </>
  );
}
